module.exports = __webpack_public_path__ + "img/wreath.5a9d956.png";